module.exports = __webpack_public_path__ + "img/01.58c060b5.jpg";